import React, { useState } from "react";
import bottom_tip_logo from "assets/img/bottom_tip_logo.png";

import "./index.less";

export default function BottomTip() {
  const t = window.t;

  return (
    <div className="tip-master">
      {/* <div className="top-right-circle-test"></div> */}
      <div id="bottom-tip-main" className="bottom-tip-main">
        <img className="tip-logo" alt="tip-logo" src={bottom_tip_logo} />
        <div
          dangerouslySetInnerHTML={{
            __html: t("welcome.gate.kingdom.new", { thisYear: "2023" }),
          }}
        ></div>
        <div></div>
      </div>
    </div>
  );
}
